import React, { useCallback } from 'react';
import LenisProvider from './components/layout/LenisProvider';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Certifications from './components/sections/Certifications';
import Contact from './components/sections/Contact';
import Navbar from './components/ui/Navbar';
import GreetingOverlay from './components/animations/GreetingOverlay';
import './App.css';

function App() {
  const smoothScrollTo = useCallback((sectionId) => {
    const section = document.getElementById(sectionId);
    if (!section) return;

    const lenis = window.lenis;
    if (lenis) {
      lenis.scrollTo(section, {
        offset: -80,
        duration: 1.5,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      });
    } else {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, []);

  return (
    <LenisProvider>
      <div className="App">
        <GreetingOverlay />
        <Navbar onNavigate={smoothScrollTo} />
        <Hero
          onScrollToProjects={() => smoothScrollTo('projects')}
          onScrollToContact={() => smoothScrollTo('contact')}
        />
        <About />
        <Projects />
        <Certifications />
        <Contact />
      </div>
    </LenisProvider>
  );
}

export default App;
